import { FC } from 'react';
import { Box } from '@chakra-ui/layout';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight'
import enterAnimation from 'lib/lottie/enter-animation.json';

type Props = {
  onComplete: Function;
}
const LottieWrapper: any = Lottie;

export const EnterAnimation: FC<Props> = ({ onComplete }) => {
  return (
    <Box position="fixed" top="-40px" left={0} right={0} bottom={0} backgroundColor="#FAFAFC" display="flex" alignItems="center" justifyContent="center">
      <Box maxWidth={600}>
        <LottieWrapper
          loop={false}
          animationData={enterAnimation}
          play
          onComplete={() => onComplete()}
        />
      </Box>
    </Box>
  )
}